<template>
  <div class="choose-columns-wrap">
    <Drawer
      title="设置按钮"
      width="350"
      :closable="false"
      :mask-closable="false"
      v-model="showDrawer"
    >
      <Checkbox v-model="isCheck">记住选择</Checkbox>
      <Divider />
      <ul class="list">
        <li
          v-for="(item, key) in colInfo"
          :key="item.key ? item.key : item.slot"
        >
          <p v-show="!item.type || item.type != 'selection'">
            <Checkbox v-model="colInfo[key]['isShow']">{{
              item.title
            }}</Checkbox>
          </p>
        </li>
      </ul>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { deepCopy } from '@/utils/utils.js'
export default {
  data() {
    return {
      showDrawer: false,
      isStorage: false,
      isCheck: false,
      columns: [],
      columnKey: [],
      colInfo: [],
      opt: null,
    }
  },
  computed: { ...mapState(['columnsModule']) },
  watch: {
    show(val) {
      console.log(val);
      this.showDrawer = val
      if (val) {
        this.init()
      }
    },
    showDrawer(val) {
      if (val) {
        this.init()
      }
    }
  },
  created() {

  },

  methods: {
    init() {

      let target = this.$store.state.columnsModule[this.columnKey]
      if (target) {
        this.colInfo = JSON.parse(JSON.stringify(target.colInfo))
        this.isCheck = target.isCheck
      } else {
        this.colInfo = this.columns.map(col => {
          return { ...col, isShow: true }
        })
        console.log(this.colInfo);
      }
    },
    // 显示
    handleShow(opt) {
      if (opt) {
        ['columnKey', 'columns'].forEach(item => {
          this[item] = opt[item]
        })
        this.opt = opt
      }
      this.showDrawer = true
    },
    // 取消
    handleCancel() {
      this.showDrawer = false

      if (this.opt && typeof this.opt.Cancel == 'function') {
        this.opt.Cancel()
      }
    },
    // 确定
    handleOk() {
      let columns = deepCopy(this.colInfo.filter(item => {
        return item.isShow === true
      }))

      let data = {};
      data[this.columnKey] = {
        colInfo: deepCopy(this.colInfo),
        isCheck: this.isCheck
      }
      columns.forEach(item => {
        delete item.__id
      })
      this.$store.dispatch('setColumnsModule', data);
      this.showDrawer = false
      if (this.opt && typeof this.opt.Ok == 'function') {
        this.opt.Ok({
          columns,
        })
      }
    }

  },

}
</script>
<style lang="scss" scoped>
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>